import "./smallModal.css";
import { useState, useEffect } from "react";
import Input from "../../fluxo-engenheiro/formBasic/Input";
import maskFormat from "../../../utils/maskFormat";
import { ModalButtons } from "../../ModalButtons/modalButtons";

interface SmallModalNaladiProps {
  titleModal?: string;
  titleDescription?: React.ReactNode;
  bodyModal?: React.ReactNode;
  buttonOne?: string;
  titleLabel?: string;
  buttonTwo?: string;
  inputMotivo?: string;
  inputNaladiNCM?: string;
  buttonThree?: string;
  onLogout?: () => void;
  onClose?: () => void;
  onConfirm?: () => void;
  className?: string;
  naladiCode?: string;
  commentText?: string;
  setCommentText?: (text: string) => void;
  setNaladiCode?: (text: string) => void;
  isButtonDisabled?: boolean;
  onDisableButton?: (disabled: boolean) => void;
  isSubmitting?: boolean;
  ncmError?: string | null; // Propriedade para receber o erro de NCM do pai
  setNcmError?: (error: string) => void; // Adicionar para permitir limpar o erro no pai
}

export const SmallModalNaladi = ({
  titleModal,
  titleDescription,
  bodyModal,
  buttonOne,
  buttonTwo,
  inputNaladiNCM,
  buttonThree,
  onClose,
  onConfirm,
  onLogout,
  className,
  naladiCode,
  setNaladiCode,
  isButtonDisabled,
  onDisableButton,
  isSubmitting,
  ncmError,
  setNcmError,
}: SmallModalNaladiProps) => {
  const [ncmMessagerError] = useState("");
  const [naladiNumber, setNaladiNumber] = useState(naladiCode || "");
  const NCM_LENGTH = 8;

  const [showNcmError, setShowNcmError] = useState(!!ncmError);

  useEffect(() => {
    setNaladiNumber(naladiCode || "");
  }, [naladiCode]);

  useEffect(() => {
    setShowNcmError(!!ncmError);
  }, [ncmError]);

  useEffect(() => {
    if (onDisableButton) {
      const cleanedNcmNumber = naladiNumber.replaceAll(/\D/g, "");
      const isNcmValid = cleanedNcmNumber.length === NCM_LENGTH;

      onDisableButton(!isNcmValid || ncmMessagerError !== "" || !!ncmError);
    }
  }, [naladiNumber, onDisableButton, ncmMessagerError, ncmError]);

  const handleNCMChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setNaladiNumber(value);
    if (setNaladiCode) {
      setNaladiCode(value);
    }
    if (showNcmError) {
      setShowNcmError(false);
      if (setNcmError) {
        setNcmError("");
      }
    }
  };

  return (
    <div className={`smallModalCorporateSession ${className}`}>
      <div className="smallModal">
        <div>
          <div className="containerTitleSmallModal">
            {titleModal && <h1 className="titleSmallModal">{titleModal}</h1>}
          </div>
          <div className="containerDescription">
            {titleDescription && (
              <span className="bodySmallModal">{titleDescription}</span>
            )}

            {bodyModal && (
              <span className="bodySmallModal" id="bodyModalStyle">
                {bodyModal}
              </span>
            )}

            {inputNaladiNCM && (
              <div style={{ marginTop: 35 }}>
                <span style={{ marginBottom: 5, display: "block" }}>
                  Informe o NALADI correto
                </span>
                <div style={{ paddingBottom: "25px" }}>
                  <Input
                    inputProps={{ "data-testid": "naladi-input" }}
                    id="material-part-desc"
                    label=""
                    placeholder="Exemplo: 00000000"
                    value={naladiNumber}
                    onChange={handleNCMChange}
                    maskFunction={maskFormat.maskCharacterNaladi}
                    applyMask={true}
                    aria-describedby="NALADI"
                    width={"39.3ch"}
                  />
                </div>
              </div>
            )}

            <ModalButtons
              buttonOne={buttonOne}
              buttonTwo={buttonTwo}
              buttonThree={buttonThree}
              onConfirm={onConfirm}
              onClose={onClose}
              onLogout={onLogout}
              isButtonDisabled={isButtonDisabled}
              isSubmitting={isSubmitting}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SmallModalNaladi;
